// components/TutorialPromptModal.js
import { useNavigate } from 'react-router-dom'
import InfoIcon from '@mui/icons-material/Info'
import SchoolIcon from '@mui/icons-material/School'
import './ConfirmModal.css'

function TutorialPromptModal ({
  isOpen,
  onClose,
  onStartTutorial,
  onDismiss
}) {
  const navigate = useNavigate()

  if (!isOpen) return null

  const handleStartTutorial = () => {
    if (onStartTutorial) {
      onStartTutorial()
    } else {
      navigate('/tutorials')
    }
    onClose()
  }

  const handleDismiss = () => {
    if (onDismiss) {
      onDismiss()
    }
    onClose()
  }

  return (
    <div className='confirm-modal-overlay' onClick={onClose}>
      <div
        className='confirm-modal-content info'
        onClick={e => e.stopPropagation()}
      >
        <div className='confirm-modal-header'>
          <InfoIcon className='modal-icon info' />
          <h3>Willkommen! Möchtest du eine kurze Einführung?</h3>
        </div>

        <div className='confirm-modal-body'>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
            <SchoolIcon style={{ fontSize: '2.5rem', color: '#2196f3' }} />
            <p style={{ margin: 0, fontSize: '1.1rem', lineHeight: '1.6' }}>
              Lerne in wenigen Minuten, wie du dein Wissen strukturiert hinzufügst und 
              effektiv nach Lösungen suchst. Unsere Anleitung zeigt dir alle wichtigen 
              Funktionen von engKnowledge.
            </p>
          </div>
          <p style={{ margin: 0, color: '#666', fontSize: '0.95rem' }}>
            Das Tutorial dauert nur etwa 5 Minuten und hilft dir, das Beste aus der 
            Plattform herauszuholen.
          </p>
        </div>

        <div className='confirm-modal-actions' style={{ flexDirection: 'column', gap: '8px' }}>
          <button 
            className='btn-confirm info' 
            onClick={handleStartTutorial}
            style={{ width: '100%', justifyContent: 'center' }}
          >
            <SchoolIcon style={{ fontSize: '1.2rem' }} />
            Jetzt starten
          </button>
          <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
            <button 
              className='btn-cancel' 
              onClick={onClose}
              style={{ flex: 1 }}
            >
              Später
            </button>
            <button 
              className='btn-cancel' 
              onClick={handleDismiss}
              style={{ flex: 1 }}
            >
              Nicht mehr anzeigen
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TutorialPromptModal

